import { useEffect, useState, useMemo, useCallback } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import { Typography } from '@mui/material';
import { MultiFilePreview, Upload } from 'src/components/upload';
import FormProvider, { RHFSelect, RHFTextField } from 'src/components/hook-form';
import { postRequest } from 'src/services';
import axios, { endpoints, simpleHeader } from 'src/utils/axios';
import { handleErrorMessages } from '../../risk-register/feching';
import Iconify from 'src/components/iconify';
const EmployeeAddDialog = ({ open, onClose, reload, currentItem, closeform, countries }) => {

    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState([]);
    const [files, setFiles] = useState([]);
    const [filePreview, setFilePreview] = useState([]);
    const [isFileDeleted, setIsFileDeleted] = useState(false);
    const [fileType, setFileType] = useState('')

    const NewUserSchema = Yup.object().shape({
      // union: Yup.string().required('Union is required'),
    });


    const defaultValues = useMemo(
        () => ({
            first_name: currentItem?.first_name || '',
            last_name: currentItem?.last_name || '',
            email: currentItem?.email || '',

            social_security_number: currentItem?.social_security_number || '',
            union: currentItem?.union || '',
        }),
        [currentItem]
    );

    useEffect(() => {
        console.log("🚀 ~ defaultValues------:", defaultValues)
        if (currentItem) {
            if (currentItem.file != null) {
                setFilePreview([{ ...currentItem.file, preview: currentItem.file.url }]);
            } else {
                setFilePreview([]);
            }
        }
    }, [defaultValues]);


    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
        defaultValues,
    });

    const {
        reset,
        setValue,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [currentItem, reset, defaultValues]);

 
    const handleDrop = useCallback(
        (acceptedFiles) => {
            const newFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                }));
            setFiles([...newFiles]);
        },
        [files]
    );

    const handleRemoveFile = (inputFile) => {
        setIsFileDeleted(true);
        setFiles([]);
        setFilePreview([]);
    };

    const handleFileType = (e) => {
        setFileType(e.target.value)
    }

    const onSubmit = handleSubmit(async (data) => {
        console.log('Form data submitted:', data);
        setLoading(true); // Set loading state to true
        const formData = new FormData(); // Create a new FormData object
        formData.append("first_name", data?.first_name || '');
        formData.append("last_name", data?.last_name || '');
        formData.append("email", data?.email || '');
        formData.append("mobile", data?.mobile || '');
        formData.append("address1", data?.address1 || '');
        formData.append("address2", data?.address2 || '');
        formData.append("suite", data?.suite || '');
        formData.append("city", data?.city || '');
        formData.append("state_id", data?.state_id || '');
        formData.append("zip", data?.zip || '');
        formData.append("country_id", data?.country_id || '');
        formData.append("social_security_number", data?.social_security_number || '');
        formData.append("union", data?.union || '');
        if (files.length > 0) {
            const file = files[0]; // Get the first file from the uploaded files
            const reader = new FileReader();
            reader.readAsDataURL(file);
            await new Promise((resolve, reject) => {
                reader.onload = function () {
                    try {
                        const base64StringWithMimeType = reader.result; // Includes MIME type (e.g., data:image/png;base64,...)
                        console.log("🚀 ~ awaitnewPromise ~ base64StringWithMimeType:", base64StringWithMimeType)
                        formData.append('signature', base64StringWithMimeType); // Append the Base64 string to formData
                        resolve();
                    } catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = function (error) {
                    reject(error);
                };
            });
        }
        try {
            const response = await postRequest(
             endpoints.accounting.employee.post_list,
                formData,
                true
            );
            console.log("🚀 ~ emplpyeeeee:", response)
            if (response.metadata && response.metadata.success) {
                reset();
                onClose();
                reload(); 
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message, // Show success message
                });
            } else {
                handleErrorMessages(response?.metadata?.message ); // Handle error messages
            }
        } catch (err) {
            console.error('Error:', err); // Log the error
            handleErrorMessages(err.message || 'Submission failed.'); // Show error message
        } finally {
            setLoading(false);
        }
    });
    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            fullWidth
            maxWidth="md"
            sx={{
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            }}
            transitionDuration={{
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            }}
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxSizing: 'content-box' }}>
                    <span
                        className='cardColor'
                        style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}>
                        &nbsp;&nbsp;  Employees  &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={onClose}>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent
                    sx={{
                        borderRadius: '1px',
                    }}
                >

                    <span
                        style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                        }}
                    >
                        Base Information
                    </span>
                    <Box
                        mt={2}
                        rowGap={2}
                        columnGap={3}
                        display="grid"
                        gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(2, 1fr)',
                        }}
                    >
                        <RHFTextField name="first_name" label="First Name" />
                        <RHFTextField name="last_name" label="Last Name" />
                        <RHFTextField type='number' name="social_security_number" label="Last 4 digits SS No." />
                        <RHFTextField type='number' name="union" label="Union Number / Code" />
                        <RHFSelect name="signature_type" label="Signature Type" value={fileType} onChange={handleFileType}>
                            <MenuItem value='Upload File'>Upload File</MenuItem>
                            <MenuItem value='Digital Signature'>Digital Signature</MenuItem>
                        </RHFSelect>
                    
                    </Box>
                    {fileType === 'Upload File' && <Box
                        mt={4}
                        rowGap={3}
                        display="grid"
                    
                        sx={{ width: '100%' }}
                    >
                        <Typography variant="subtitle2">Upload Signature</Typography>
                        <Upload onDrop={handleDrop} onRemove={handleRemoveFile}  />
                    </Box>}
                    {fileType === 'Digital Signature' && <Box
                        mt={4}
                        rowGap={3}
                        display="grid"
                        // gridTemplateColumns={{
                        //     xs: 'repeat(1, 1fr)',
                        // }}
                        sx={{ width: '100%' }}
                    >
                        <Typography variant="subtitle2">Upload Signature</Typography>
                        <Upload onDrop={handleDrop} onRemove={handleRemoveFile} />
                    </Box>}


                    <Box sx={{ my: 3 }}>
                        <MultiFilePreview
                            files={files?.length > 0 ? files : filePreview}
                            onRemove={handleRemoveFile}
                            setFileDeleted={setIsFileDeleted}
                        />
                    </Box>


                </DialogContent>

                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={onClose}>
                        Cancel
                    </Button>
                    <LoadingButton
                        className='dark-button'
                        disabled={ loading }
                        loading={ loading }
                        onClick={ onSubmit }
                        variant="contained"
                    >
                        Save
                    </LoadingButton>

                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};
export default EmployeeAddDialog;